// extracted by mini-css-extract-plugin
export default {"root":"CLeMSr","vertical":"yjSkG5","horizontal":"xMgVB5"};